import { Card, CardBody } from 'reactstrap'
import BreadcrumbBar from '~/components/shared/BreadcrumbBar'

function MfaSetup () {
  const breadcrumbs = [
    { name: 'Login Help', href: '/login-help' },
    { name: 'MFA Basics', href: '/login-help/using-mfa-basics' }
  ]

  return (
    <>
      <BreadcrumbBar breadcrumbs={breadcrumbs} />

      <h2 className='pb-2'>Multifactor Authentication Basics</h2>

      <Card>
        <CardBody>
          <p>
            <p>
              When you log on to an SCP system, you may be asked to verify your identity through
              your chosen multifactor authentication method. Follow the below instructions to
              complete the authentication process.
            </p>
            <p>
              For all authentication methods, you can bypass multifactor authentication for 24 hours
              by checking <b>Do not challenge me on this device for the next 24 hours.</b>
            </p>
            <p>
              If you have enabled more than one authentication method, you can choose the one you
              want to use by clicking the arrow button next to the Okta symbol.
            </p>
            <img src='/static/img/using-mfa-basics.png' alt='mfa basics' />
          </p>
        </CardBody>
      </Card>
    </>
  )
}

MfaSetup.publicAccess = true

MfaSetup.getInitialProps = () => ({
  title: 'MFA Basics'
})

export default MfaSetup
